import React from "react";
import DescriptionSlider from "./DescriptionSlider";
import DailyPlaining from "./DailyPlaining";
import Header from "../common/Header";
import { Link } from "react-router-dom";

const ProductivityDescription = () => {
  return (
    <>
      <div className="bg-light_purple7 rounded-2xl overflow-x-hidden  h-[calc(100vh-32px)]">
        <div className=" overflow-hidden  px-2 xs:px-5">
          <Header text="Dashboard" />
        </div>
        <div className="flex flex-col md:flex-row justify-between pt-[9px] lg:pt-[9px] lg:w-[100%] overflow-hidden px-2 xs:px-5 ">
          <div>
            <div className=" flex items-center justify-between">
              <p className="text-[14px] font-bold text-black">
                Today's Productivity
              </p>
              <Link
                to="/"
                className="text-[14px] inline-block font-normal text-black rounded-[36px] bg-[rgba(111,_106,_248,_0.12)] p-[8px_22px] hover:bg-primary hover:text-white duration-200">
                Back
              </Link>
            </div>
            <div className="mt-[18px] rounded-[10px] items-center w-full md:w-[100%] overflow-x-hidden md:overflow-y-auto overflow_x_scroll_style md:h-[calc(100vh-200px)]">
              <div className="flex items-center bg-light_purple3">
                <div className="w-[161px] md:w-[30%] lg:w-[120px] xl:w-[220px] border-r border-[#f2f2f2]">
                  <div className="py-2.5 pl-[15px]">
                    <h4 className="text-black font-bold text-sm">Goal</h4>
                  </div>
                </div>
                <div className="w-[427px] md:w-[80%] lg:w-full ">
                  <div className="py-2.5 pl-[15px]">
                    <h4 className="text-black font-bold text-sm">
                      Description
                    </h4>
                  </div>
                </div>
              </div>
              <div className="flex items-center bg-[#fbfbfb] border border-[#f2f2f2]">
                <div className="w-[161px] md:w-[30%] lg:w-[120px] xl:w-[220px]">
                  <div className="pl-[15px]">
                    <p className="text-black font-medium text-sm">
                      New Contacts
                    </p>
                  </div>
                </div>
                <div className="w-[427px] md:w-[80%] lg:w-full  border-l border-[#f2f2f2]">
                  <div className="py-[36px] px-[15px]">
                    <p className="text-black font-normal text-xs 3xl:text-[13px] opacity-70">
                      User will need to be able to set the target amount of new
                      contacts they are looking to make in a day, for example if
                      they input 10 new contacts when they enter their first new
                      contact for the day it will update to 10%,20%,30% and so
                      on until they reach their goal of 10 ( 100% ) 
                    </p>
                  </div>
                </div>
              </div>
              <div className="flex items-center bg-[#f6f6f6] border border-[#f2f2f2]">
                <div className="w-[161px] md:w-[30%] lg:w-[120px] xl:w-[220px]">
                  <div className="pl-[15px]">
                    <p className="text-black font-medium text-sm">Follow ups</p>
                  </div>
                </div>
                <div className="w-[427px] md:w-[80%] lg:w-full  border-l border-[#f2f2f2]">
                  <div className="py-[36px] px-[15px]">
                    <p className="text-black font-normal text-xs 3xl:text-[13px] opacity-70">
                      The system will know how many follow ups they have
                      scheduled in a day by the users inputted data. For example
                      if there are 5 follow ups scheduled as they complete their
                      first follow up 1/5 it would update to 20%.
                    </p>
                  </div>
                </div>
              </div>
              <div className="flex items-center bg-[#fbfbfb] border border-[#f2f2f2]">
                <div className="w-[161px] md:w-[30%] lg:w-[120px] xl:w-[220px]">
                  <div className="pl-[15px]">
                    <p className="text-black font-medium text-sm">
                      Schedule Meeting
                    </p>
                  </div>
                </div>
                <div className="w-[427px] md:w-[80%] lg:w-full  border-l border-[#f2f2f2]">
                  <div className="py-[36px] px-[15px]">
                    <p className="text-black font-normal text-xs 3xl:text-[13px] opacity-70">
                      User will need to be able to set the target amount of
                      Scheduled Meetings they are looking to make in a day, for
                      example if they input a target of 10 scheduled meetings
                      when they enter their first new meeting appointment for
                      the day it will update to 10%,20%,30% and so on until they
                      reach their goal of 10 ( 100% ).
                    </p>
                  </div>
                </div>
              </div>
              <div className="flex items-center bg-[#f6f6f6] border border-[#f2f2f2]">
                <div className="w-[161px] md:w-[30%] lg:w-[120px] xl:w-[220px]">
                  <div className="pl-[15px]">
                    <p className="text-black font-medium text-sm">Reconnects</p>
                  </div>
                </div>
                <div className="w-[427px] md:w-[80%] lg:w-full  border-l border-[#f2f2f2]">
                  <div className="py-[36px] px-[15px]">
                    <p className="text-black font-normal text-xs 3xl:text-[13px] opacity-70">
                      These are their contacts they have not contacted within
                      the last 30 days. If there us 10 contacts in their
                      reconnect section as they log a contact it will update in
                      this example 10% for each new reconnect made
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full md:w-[300px] lg:w-[340px] xl:w-[395px] 2xl:w-[500px] mt-4 md:mt-0 ">
            <DescriptionSlider />

            <DailyPlaining />
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductivityDescription;
